import { useRouter } from 'next/router'
import React, { useState, useRef } from 'react'
import Image from 'next/legacy/image'
import { Swiper, SwiperSlide } from 'swiper/react'
import Link from 'next/link'
import PuppyCard from '../newPuppyCard'
// Utils
import useMediaQuery from '../../utils/publicApi'
import styles from './breedPreview.module.scss'
import cn from 'classnames'
import {
  trainingConverter,
  energyConverter,
  sheddingConverter,
  sizeConverter,
} from '../../utils/converter'

const BreedPreview = ({ breed, number }) => {
  const router = useRouter()
  const isMobile = useMediaQuery('(max-width:600px)')

  const showButtons = breed?.dogs?.length >= 3
  /* Swiper Handlers   */
  const ref = useRef(null)

  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  const goNext = async () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      await ref.current.swiper.slideNext()
      setIsBeginning(ref.current?.swiper?.isBeginning)
      setIsEnd(ref.current?.swiper?.isEnd)
    }
  }

  const goPrev = async () => {
    if (ref.current !== null && ref.current.swiper !== null) {
      await ref.current.swiper.slidePrev()
      setIsBeginning(ref.current?.swiper?.isBeginning)
      setIsEnd(ref.current?.swiper?.isEnd)
    }
  }

  const AllFacts = [
    {
      img: '/facts/green/size.svg',
      title: 'Size',
      alt: 'Dog icon',
      value: `${sizeConverter(breed?.size)}`,
    },
    {
      img: '/facts/green/energy.svg',
      title: 'Energy',
      alt: 'Thunderbold icon',
      value: `${energyConverter(breed?.energyLevel)}`,
    },
    {
      img: '/facts/green/shedding.svg',
      title: 'Shedding',
      alt: 'Dog shedder icon',
      value: `${sheddingConverter(breed?.amountOfShedding)}`,
    },
    {
      img: '/facts/green/weight.svg',
      title: 'Weight',
      alt: 'Weight icon in pounds',
      value: `${breed?.weightMin} - ${breed?.weightMax} lbs`,
    },
    {
      img: '/facts/green/training.svg',
      title: 'Trainability',
      alt: 'Badge icon',
      value: `${trainingConverter(breed?.easyToTrain)}`,
    },
    {
      img: '/facts/green/life-span.svg',
      title: 'Life span',
      alt: 'Heart beat icon',
      value: `${breed?.lifeSpanMin} to ${breed?.lifeSpanMax} years`,
    },
  ]

  const ThreeFacts = AllFacts.slice(0, 3)

  const AllDescription = breed?.description
  const ShortDescriptionMobile = () => {
    return (
      <div onClick={() => showMore()}>
        <div className={styles.shortDescription}>
          {breed?.description?.slice(0, 145)}...{' '}
          <span>
            Learn more
            <img
              src="/arrow-green-down2.svg"
              className={styles.arrowDown}
              alt="green down arrow"
            />
          </span>
        </div>
      </div>
    )
  }
  const ShortDescription = breed?.description?.slice(0, 145) + '...'

  const [allFacts, setAllFacts] = useState(false)
  const [allDescription, setAllDescription] = useState(false)

  const showMore = () => {
    setAllFacts(true)
    setAllDescription(true)
  }
  const showLess = () => {
    setAllFacts(false)
    setAllDescription(false)
  }
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.containerTitle}>
          {' '}
          <div>{number + 1}.</div> <h1> {breed.name}</h1>
        </div>
        <div>
          <Link href={`/search?breed=${breed.slug}`} className={styles.btnGo}>
            View all
          </Link>
        </div>
      </div>
      <div className={styles.info}>
        {isMobile ? (
          breed.description !== null ? (
            !allDescription ? (
              <div className={styles.description}>
                {ShortDescriptionMobile()}
              </div>
            ) : (
              <div className={styles.description}>{AllDescription}</div>
            )
          ) : null
        ) : breed.description !== null ? (
          !allDescription ? (
            ShortDescription
          ) : (
            AllDescription
          )
        ) : null}
        <div className={styles.facts}>
          {!allFacts ? (
            <>
              {' '}
              {!isMobile
                ? ThreeFacts.map((fact, i) => {
                    return (
                      <div key={i} className={styles.fact}>
                        <img src={fact.img} alt={fact.alt} />
                        <div>
                          <h5>{fact.title}</h5>
                          <p>{fact.value}</p>
                        </div>
                      </div>
                    )
                  })
                : null}
            </>
          ) : (
            <>
              {AllFacts.map((fact, i) => {
                return (
                  <div key={i} className={styles.fact}>
                    <img src={fact.img} alt={fact.alt} />
                    <div>
                      <h5>{fact.title}</h5>
                      <p>{fact.value}</p>
                    </div>
                  </div>
                )
              })}
            </>
          )}
        </div>
        {breed.description !== null ? (
          <>
            {!allDescription && !isMobile && (
              <div className={styles.learnMore} onClick={() => showMore()}>
                Learn more <span className={styles.arrowDown} />
              </div>
            )}
            {allDescription && (
              <div className={styles.learnLess} onClick={() => showLess()}>
                View less <span className={styles.arrowUp} />
              </div>
            )}
          </>
        ) : null}
      </div>

      <div className={styles.sectionImages}>
        {!isMobile && (
          <div className={styles.profile}>
            <Image
              quality={100}
              layout="intrinsic"
              objectFit="cover"
              width={230}
              height={230}
              alt={breed.name}
              src={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${
                breed?.coverPicture && breed?.coverPicture?.small
              }`}
              placeholder="blur"
              blurDataURL={`/_next/image?url=${`${
                process.env.NEXT_PUBLIC_MEDIA_BUCKET
              }${breed?.coverPicture && breed?.coverPicture?.small}`}&w=16&q=1`}
            />
          </div>
        )}
        {/* eslint-disable-next-line */}

        {isMobile ? (
          <div className={styles.gridImages}>
            {/* Swiper Mobile */}
            <Swiper
              speed={1000}
              initialSlide={0}
              grabCursor
              // pagination={{ clickable: true }}
              breakpoints={{
                1020: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
                860: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                540: {
                  slidesPerView: 'auto',
                  spaceBetween: 10,
                },
                360: {
                  slidesPerView: 'auto',
                  spaceBetween: 10,
                },
              }}
              ref={ref}
            >
              <SwiperSlide>
                <div className={styles.profileMobile}>
                  <Image
                    quality={100}
                    layout="intrinsic"
                    objectFit="cover"
                    width={150}
                    height={150}
                    alt={breed.name}
                    src={`${process.env.NEXT_PUBLIC_MEDIA_BUCKET}${
                      breed?.coverPicture && breed?.coverPicture?.small
                    }`}
                    placeholder="blur"
                    blurDataURL={`/_next/image?url=${`${
                      process.env.NEXT_PUBLIC_MEDIA_BUCKET
                    }${
                      breed?.coverPicture && breed?.coverPicture?.small
                    }`}&w=16&q=1`}
                  />
                </div>
              </SwiperSlide>
              {breed?.dogs.slice(0, 6).map((d, i) => (
                <SwiperSlide key={i}>
                  <div className={styles.cardContainer}>
                    <PuppyCard dog={d} />
                  </div>
                </SwiperSlide>
              ))}
              <SwiperSlide>
                <div
                  className={styles.viewMore}
                  role="img"
                  aria-label="Doodle of dog leaning over an edge and smiling with heart icons next to her"
                  onClick={() => router.push(`/search?breed=${breed.slug}`)}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        ) : (
          <div className={styles.gridImages}>
            {/* Swiper Desktop */}
            {showButtons && (
              <>
                <button
                  className={cn({
                    [styles.swiperButton]: true,
                    [styles.swiperPrev]: !isBeginning,
                    [styles.hidePrev]: isBeginning,
                  })}
                  onClick={goPrev}
                />
                <button
                  className={cn({
                    [styles.swiperButton]: true,
                    [styles.swiperNext]: !isEnd,
                    [styles.hideNext]: isEnd,
                  })}
                  onClick={goNext}
                />
              </>
            )}
            <Swiper
              speed={1000}
              initialSlide={0}
              grabCursor
              pagination={{ clickable: true }}
              breakpoints={{
                1020: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
                860: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
                540: {
                  slidesPerView: 'auto',
                  spaceBetween: 10,
                },
                360: {
                  slidesPerView: 'auto',
                  spaceBetween: 10,
                },
              }}
              ref={ref}
            >
              {breed?.dogs.slice(0, 6).map((d, i) => (
                <SwiperSlide key={i}>
                  <div className={styles.cardContainer}>
                    <PuppyCard dog={d} />
                  </div>
                </SwiperSlide>
              ))}
              <SwiperSlide>
                <div
                  className={styles.viewMore}
                  role="img"
                  aria-label="Doodle of dog leaning over an edge and smiling with heart icons next to her"
                  onClick={() => router.push(`/search?breed=${breed.slug}`)}
                />
              </SwiperSlide>
            </Swiper>
          </div>
        )}
        {number + 1 < 10 ? <div className={styles.divider} /> : null}
      </div>
    </div>
  )
}

export default BreedPreview
